import { motion } from "framer-motion"
import { cn } from "src/lib/utils"

export default function HoverBg({ className, layoutId }: { className?: string, layoutId?: string }) {
    return (
        <motion.div
            layoutId={layoutId}
            transition={{ duration: 0.4 }}
            className={cn("absolute inset-0 h-full w-full rounded-full gradient-bg-hover", className)}
        />
    )
}